export default "__VITE_ASSET__8c0c0b87__"